import { call, put, select, takeLatest, actionChannel, take, ActionPattern } from 'redux-saga/effects';
import { delay } from 'redux-saga/effects';
import { Logger } from 'logger';
import { setEvents, setEventsError, displayGlobalEvent, setCurrentEvent, unsetCurrentEvent } from './actions';
import { getEventsAudioIsMuted } from './selectors';
import { getEvents, getSpeechAudio } from './api';
import { FETCH_EVENTS_REQUEST, APPEND_EVENT_SUCCESS, PUSH_GLOBAL_EVENT, DISPLAY_GLOBAL_EVENT } from './constants';
import audioFile from '../../assets/sounds/alert1.mp3';
import { Action } from 'redux-actions';

const debugLog = Logger.create('events/sagas.ts')

function* fetchEvents(param: any) {
  try {
    const { data } = yield call(getEvents, param.payload);

    yield put(setEvents(data));
  } catch (err:any) {
    yield put(setEventsError(err.message));
  }
}

function* prepareGlobalEvent({ payload: { event, token } }: any) {
  try {
    const { data, error } = yield call(getSpeechAudio, {
      token,
      text: event.message.text
    });

    if (error) throw error

    yield put(displayGlobalEvent({
      event,
      audio: new Audio(data.audioContent)
    }))
  } catch {
    yield put(displayGlobalEvent({
      event,
      audio: null
    }))
  }
}

export function* queueWatcher() {
  const channel: ActionPattern<Action<any>> = yield actionChannel(DISPLAY_GLOBAL_EVENT);

  while (true) {
    const { payload: { event, audio } } = yield take(channel);
    const audioIsMuted: boolean = yield select(getEventsAudioIsMuted);

    yield put(setCurrentEvent(event))

    if (audio && !audioIsMuted) {
      yield call([audio, 'play'])
      yield delay((audio.duration + 1) * 1000)
    } else {
      yield delay(5000)
    }

    yield put(unsetCurrentEvent())
  }
}

function* playAudioAlert(file: any) {
  try {
    const audioIsMuted: boolean = yield select(getEventsAudioIsMuted);

    if (!audioIsMuted) {
      const audioAlert = new Audio(file);

      yield call(audioAlert.play.bind(audioAlert));
    }
  } catch (err) {
    debugLog(err);
  }
}

export function* sagaWatcher() {
  yield takeLatest(FETCH_EVENTS_REQUEST, fetchEvents);
  yield takeLatest(PUSH_GLOBAL_EVENT, prepareGlobalEvent);
}

export function* newEventWatcher() {
  yield takeLatest(APPEND_EVENT_SUCCESS, playAudioAlert, audioFile);
}


const gens = [
  sagaWatcher(),
  newEventWatcher(),
  queueWatcher()
];
export default gens;
